import { Outlet } from "react-router-dom";

export function ClinicSchedule() {
  return <Outlet />;
}

export default ClinicSchedule;
